import { PureComponent } from "react";
import { componentStyles } from "./person-component.scss";
import { trackCommunityEvent } from "/services/bigbrain-service";
import { SHOW_TEMPLATES } from "/constants/bigbrain-event-types";

export default class PersonComponent extends PureComponent {
  trackLinkClick(event) {
    const { target } = event;
    const href = target.href || target.parentElement.href; /* For Logo image*/
    const isUser = href.indexOf("/user/") != -1;
    const id = href.substring(href.lastIndexOf("/") + 1);
    trackCommunityEvent(SHOW_TEMPLATES, { kind: isUser ? "user" : "account", info1: id });
  }

  render() {
    const { personName, personImageSrc, personUrl, vendorName, vendorUrl, namePrefix, postfix } = this.props;
    return (
      <div className="person-component">
        {personImageSrc && (
          <div className="person-image">
            <img src={personImageSrc} alt={personName} />
          </div>
        )}
        <div className="text-container">
          <div className="name-and-vendor-container text">
            <span>{namePrefix}</span>
            {personUrl && (
              <a className="person-name" href={personUrl} onClick={this.trackLinkClick}>
                {personName}
              </a>
            )}
            {!personUrl && <span className="person-name">{personName}</span>}
            <span> from </span>
            {vendorUrl && (
              <a className="vendor-name" href={vendorUrl} onClick={this.trackLinkClick}>
                {vendorName}
              </a>
            )}
            {!vendorUrl && <span className="vendor-name">{vendorName}</span>}
            <span className="story text">{postfix}</span>
          </div>
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

PersonComponent.defaultProps = {
  personName: "",
  personImageSrc: "",
  personUrl: "",
  vendorName: "",
  vendorUrl: "",
  namePrefix: "Hi I'm ",
  postfix: "This is how I use monday.com"
};
